import { Component, OnInit, Optional } from '@angular/core';
import { MetaDirective } from '../../../shared/directives/meta.directive';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { SearchMode } from '../../../shared/enum/searchMode';
import { AbstractSearchComponent } from '../../../shared/components/abstract-component/abstract-search.component';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { PersongbSucheStandardComponent } from './suche-standard/persongb-suche-standard.component';
import { PersongbSucheErweitertComponent } from './suche-erweitert/persongb-suche-erweitert.component';
import { PersonByEgbpidLoadResolverComponent } from './suche-egbpid/person-by-egbpid-load-resolver.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-persongb-suche',
  templateUrl: './persongb-suche.component.html',
  styleUrls: ['./persongb-suche.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavContent,
    PersongbSucheStandardComponent,
    PersongbSucheErweitertComponent,
    PersonByEgbpidLoadResolverComponent,
    NgbNavOutlet,
    TranslatePipe
  ]
})
export class PersongbSucheComponent extends AbstractSearchComponent implements OnInit {
  searchMode: SearchMode;
  tabStandardActive = false;

  constructor(
    stateService: SearchStateService,
    private formatConfig: FormatConfigService,
    @Optional() private metaDirective?: MetaDirective
  ) {
    keysToTranslate([
      'Personenregister',
      'Suchergebnis',
      'person.breadcrumbSuche',
      'searchZuWenigSuchkriterien',
      'atLeast2Letters',
      'cantSearchAlone'
    ]);
    super(stateService);
  }

  ngOnInit() {
    this.searchMode = this.stateService.lastSearchMode || SearchMode.searchStandard;
  }

  saveTabSettings(event: boolean) {
    this.tabStandardActive = event;
  }
}
